$(document).ready(function(){

  var form = $('#form_newsletter');

  form.on('submit', function(e) {
    e.preventDefault();
    
    var url = window.location.href;
    var data = $(this).serialize();
    data[csrfTokenName] = csrfTokenValue;

    $.post(url, data)
    .done(function(data) {

      if (!data.success) {
        // Error
        console.log(data.message);
        setTimeout(function(){
          form.find('.msg__inner').text(data.message);
        }, 400);
      }
      else {
        // Success
        console.log('Success');
        setTimeout(function(){
          form.find('.msg__inner').text(data.message);
          form.find('.email').val('');
        }, 400);
      }
    });

  });

});
